export function isValidFileType(file: File, accept: string): boolean {
  if (!accept) {
    return true;
  }
  const acceptTypes = accept.split(',').map((type) => type.trim());
  return acceptTypes.some((acceptType) => {
    if (acceptType.includes('/')) {
      if (acceptType.endsWith('/*')) {
        const baseType = acceptType.slice(0, -2);
        return file.type.startsWith(baseType);
      } else {
        return file.type === acceptType;
      }
    }
    if (acceptType.startsWith('.')) {
      const fileName = file.name.toLowerCase();
      return fileName.endsWith(acceptType.toLowerCase());
    }
    const fileName = file.name.toLowerCase();
    return fileName.endsWith(`.${acceptType.toLowerCase()}`);
  });
}
